// import React, { useEffect, useState } from "react";
// import { getPosts } from "./api/forumApi";
// import ForumCard from "../components/ForumCard";
// import { useNavigate } from "react-router-dom";

// export default function Forums() {
//   const [posts, setPosts] = useState([]);
//   const navigate = useNavigate();

//   useEffect(() => {
//     getPosts().then(res => {
//       setPosts(res.data);
//     });
//   }, []);

//   return (
//     <div className="container">
//       <h1>Announcements</h1>

      


//       <div className="forum-list">
//         {posts.map(post => (
//           <ForumCard key={post.id} post={post} />
//         ))}
//       </div>
//     </div>
//   );

// if (navigator.userAgent.includes("VortexDesktop")) {
//     console.log("Running inside the Electron app");
//       <button className="create-btn" onClick={() => navigate("/create")}>
//         + Create Post
//       </button>    
// } else {
//     console.log("Normal web browser");
//     <p>sorry you can't post</p>
// }  
// }
import React, { useEffect, useState } from "react";
import { getPosts } from "./api/forumApi";
import ForumCard from "../components/ForumCard";
import { useNavigate } from "react-router-dom";

export default function Forums() {
  const [posts, setPosts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    getPosts().then(res => {
      setPosts(res.data);
    });
  }, []);

  // Detect Electron app
  const isElectron = navigator.userAgent.includes("VortexDesktop");

  return (
    <div className="container">
      <h1>Announcements</h1>

      {isElectron ? (
        <button
          className="create-btn"
          onClick={() => navigate("/create")}
        >
          + Create Post
        </button>
      ) : (
        
        
        <p>Sorry, you can't create posts</p>
      )}
      <br />
      <br />

      <div className="forum-list">
        {posts.map(post => (
          <ForumCard key={post.id} post={post} />
        ))}
      </div>
    </div>
  );
}